import type { NotificationProps } from '../notification'

import { useNavigate } from 'react-router-dom'

import { Notification } from '../notification'

export interface FileNotificationProps extends NotificationProps {
  id: string
  place?: string
  clientName: string
  patientId: string
  createdAt: string
  patientName: string
}

export function FileNotification ({
  createdAt,
  patientId,
  clientName,
  patientName,
  place,
  ...rest
}: FileNotificationProps): JSX.Element {
  let navigate = useNavigate()

  return (
    <Notification
      title='New File'
      date={new Date(createdAt)}
      onClick={() => {
        navigate(`/patient/${clientName}/${patientId}/patientFolder`)
        rest.onDismiss()
      }}
      {...rest}
    >
      New file uploaded by {patientName}
    </Notification>
  )
}
